'use client';

import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { useEffect, useState } from 'react';

interface Slide {
  image: string;
  title: string;
  description: string;
  extra?: string;
}

const slides: Slide[] = [
  {
    image: '/banner/siberia1.jpg',
    title: 'Путешествие по Сибири',
    description: 'Исследуй красоту природы и свежий воздух.',
    extra: 'Томская область, 2025',
  },
  {
    image: '/banner/siberia2.jpg',
    title: 'Зимняя сказка',
    description: 'Сибирь зимой — это магия снега и тишины.',
    extra: 'Февральские дали',
  },
  {
    image: '/banner/siberia3.jpg',
    title: 'Лето в тайге',
    description: 'Время для походов, костров и ягод.',
    extra: 'Июльский лес',
  },
];

export default function BannerBig() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(
        (prev) => (prev + 1) % slides.length,
      ); /* организовать бесконечный цикл по массиву. */
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <a
      href="http://siberia-tours.com/?utm_source=new_sib&utm_term=%D0%9F%D1%83%D1%82%D0%B5%D1%88%D0%B5%D1%81%D1%82%D0%B2%D0%B8%D0%B5%20%D0%BF%D0%BE%20%D0%A1%D0%B8%D0%B1%D0%B8%D1%80%D0%B8&yclid=11346720711500365823"
      target="_blank"
    >
      <div className="relative h-[100px] w-full overflow-hidden rounded-2xl shadow-lg">
        <AnimatePresence mode="wait">
          <motion.div
            key={slides[index].image}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 w-full h-full"
          >
            <Image
              src={slides[index].image}
              alt={slides[index].title}
              fill
              className="object-cover"
              priority
            />
            <div className="absolute inset-0 bg-black/50" />
          </motion.div>
        </AnimatePresence>

        <div className="absolute z-10 inset-0 flex flex-col justify-center items-center text-center text-white px-4">
          <h2 className="text-xl md:text-2xl font-bold drop-shadow-md">{slides[index].title}</h2>
          <p className="mt-2 text-md md:text-lg">{slides[index].description}</p>
          {slides[index].extra && (
            <span className="mt-auto text-sm text-gray-300">{slides[index].extra}</span>
          )}
        </div>
      </div>
    </a>
  );
}
